import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import setLoaderAction from "./loaderAction";
import * as toastAction from "../actions/toastAction";
import { DEFAULT_ERROR_MESSAGE, ERROR_TIMEOUT, INVALID_SESSION } from "../../App.config";
import history from "../../utilities/history";
import { closeRemoveModal } from "./modalActions";
import { isSessionValid } from "./profileAction";

function setUserRolePermissions(userPermissions) {
    return {
        type: types.SET_USER_PERMISSIONS,
        userPermissions
    };
}

function setReports(data) {
    return {
        type: types.SET_REPORTS,
        data
    };
}

function setReportsForCompany(data) {
    return {
        type: types.SET_REPORTS_DETAILS,
        data
    };
}

function setGetAuthUserRoles(userRoles) {
    return {
        type: types.SET_USER_ROLES,
        userRoles
    };
}

function setAllAuthUsers(allAuthUsers) {
    return {
        type: types.SET_AUTH_USERS,
        allAuthUsers
    };
}

function setAuthUser(authUser) {
    return {
        type: types.SET_AUTH_USER,
        authUser
    };
}

function isUserSet(isUserSet) {
    return {
        type: types.IS_USER_SET,
        isUserSet
    };
}

function setTotalRecordOfUserList(totalRecord) {
    return {
        type: types.SET_TOTAL_RECORD_OF_USER_LIST,
        totalRecord
    }
}

function setIsUserDelete(isUserDelete) {
    return {
        type: types.SET_IS_USER_DELETE,
        isUserDelete
    }
}

function setCompanyList(companyList) {
    return {
        type: types.SET_COMPANY_LIST,
        companyList
    }
}

function setDomainList(domainList) {
    return {
        type: types.SET_DOMAIN_LIST,
        domainList
    }
}

function setBackupUserList(backupUserList) {
    return {
        type: types.SET_BACKUP_USERS,
        backupUserList
    }
}

function setBackupUserFlag(backupUserFlag) {
    return {
        type: types.SET_BACKUP_USERS_FLAG,
        backupUserFlag
    }
}

function setSelectedCompany(selectedCompany) {
    return {
        type: types.SET_SELECTED_COMPANY,
        selectedCompany
    }
}

function setVerifyOtpData(otpData) {
    return {
        type: types.SET_OTP_DATA,
        otpData
    };
}

function setDomainFlag(domainFlag) {
    return {
        type: types.SET_DOMAIN_FLAG,
        domainFlag
    }
}

function setRegionList(regionList) {
    return {
        type: types.SET_REGION_LIST,
        regionList
    }
}

function setDepartmentList(departmentList) {
    return {
        type: types.SET_DEPARTMENT_LIST,
        departmentList
    }
}

function setCompanyServices(companyServices) {
    return {
        type: types.SET_COMPANY_SERVICES,
        companyServices
    }
}

function setUserCompanyServices(companyServices) {
    return {
        type: types.SET_USER_COMPANY_SERVICES,
        companyServices
    }
}

function setIsBackupAssigned(isBackupAssigned) {
    return {
        type: types.SET_ISBACKUP_ASSIGNED,
        isBackupAssigned
    }
}

function successMessageForBackupUserAssigned(successMessageForBackupUserAssigned) {
    return {
        type: types.SET_SUCCESS_MESSAGE_FOR_BACKUP_USER_ASSIGNED,
        successMessageForBackupUserAssigned
    }
}

function openSimpleModalForTermiantion(openSimpleModalForTermiantion) {
    return {
        type: types.OPEN_SIMPLE_MODAL_FOR_TERMINATION,
        openSimpleModalForTermiantion
    }
}

function setLevelItem(data) {
    return {
        type: types.SET_LEVEL_ITEM,
        data
    }
}

function setMyReports(data) {
    return {
        type: types.SET_MY_REPORT,
        data
    }
}

function setSelectedDomainValues(selectedDomainUsers) {
    return {
        type: types.SET_SELECTED_DOMAIN_VALUES,
        selectedDomainUsers,
        isSelectedUserLoaded: true,
        confirmationValue: false
    }
}

function resetSelectedDomainValues(confirmationValue, isSelectedUserLoaded) {
    return {
        type: types.RESET_SELECTED_DOMAIN_VALUES,
        confirmationValue,
        isSelectedUserLoaded
    }
}

function setReportModules(reportModules) {
    return {
        type: types.SET_REPORT_MODULES,
        reportModules
    }
}

function setCompanyAssignedLevels(data) {
    return {
        type: types.SET_COMPANY_ASSIGNED_LEVELS,
        companyAssignedLevels: data
    }
}

function setCompanyLevelItems(data) {
    return {
        type: types.SET_COMPANY_LEVEL_ITEMS,
        companyLevelItems: data
    }
}



//export functions
export const getReportDetailsByCompany = (companyId, isLangEng) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getReportsByCompanyId(companyId, isLangEng)
        .then(({ data }) => {
            dispatch(setLoaderAction(false));
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                let reports = [];
                let modules = [];
                let groupedModuleReports = [];
                data.response && data.response.length > 0 && data.response.map((report) => {

                    let isModuleExist = modules.findIndex(y => y.moduleName == report.moduleName)
                    isModuleExist === -1 && modules.push({
                        moduleName: report.moduleName
                    })

                    let index = reports.findIndex(x => x.reportId === report.reportId);
                    if (index !== -1) {
                        reports[index].access.push(
                            {
                                roleId: report.roleId,
                                isAccess: report.isAccess
                            }
                        );
                    }
                    else {
                        report.access = [
                            {
                                roleId: report.roleId,
                                isAccess: report.isAccess
                            }
                        ];
                        reports.push(report);
                    }


                })
                modules && modules.length && modules.map((module) => {
                    let moduleReports = [];
                    moduleReports = reports.filter(x => x.moduleName == module.moduleName);

                    groupedModuleReports.push({
                        moduleName: module.moduleName,
                        groupedReports: moduleReports
                    })

                })
                dispatch(setReportsForCompany(groupedModuleReports));
            } else {
                if (data.errorMessage) {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            // dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetReport = (data) => (dispatch) => {
    dispatch(setReportsForCompany(data));
}

//export functions
export const deleteReportByCompanyId = (companyId, reportId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .deleteReport(companyId, reportId)
        .then(({ data }) => {
            dispatch(setLoaderAction(false));
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(getReportDetailsByCompany(companyId));
            } else {
                if (data.errorMessage) {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            // dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const updateReportAccess = (companyId, roleId, isAccess, reportId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .updateReportAccess(companyId, roleId, isAccess, reportId)
        .then(({ data }) => {
            dispatch(setLoaderAction(false));
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(getReportDetailsByCompany(companyId));
            } else {
                if (data.errorMessage) {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            // dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

//export functions
export const getUserRolePermissions = () => (dispatch) => {
    // dispatch(setLoaderAction(true));
    return apiServices
        .getUserRolePermissions()
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                // dispatch(setLoaderAction(false));
                dispatch(setUserRolePermissions(data.response));
            } else {
                if (data.errorMessage) {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            // dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const addUser = (payload) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .addUser(payload)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
                dispatch(resetAuthUser());
                history.push('/user-list');
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getAuthUserRoles = (companyId) => (dispatch) => {
    // dispatch(setLoaderAction(true));
    return apiServices
        .getAuthUserRoles(companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                // dispatch(setLoaderAction(false));
                // data.response.push({
                //     authUserRoleId: 5,
                //     name: "BROKER",
                //     uniqueSlug: "CBDHD"
                // })
                dispatch(setGetAuthUserRoles([]));
                dispatch(setGetAuthUserRoles(data.response));
            } else {
                if (data.errorMessage) {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    // dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            // dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const getLevelItemByLevelId = (levelId, companyId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getLevelItemByLevelId(levelId, companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setLevelItem(data.levelItem))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const getAllAuthUsers = (companyId, payload, isCompanySet = true) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getAllAuthUsers(payload)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                if (companyId)
                    dispatch(getCompanyServiceSettings(companyId));
                dispatch(setLoaderAction(false));
                dispatch(setAllAuthUsers([]));
                dispatch(setAllAuthUsers(data.response.data));
                dispatch(setTotalRecordOfUserList(data.response.recordsTotal));
                isCompanySet && dispatch(setSelectedCompany(companyId));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const getAuthUserById = (companyId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getAuthUserById(companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setAuthUser({}));
                dispatch(setAuthUser(data.response));
                dispatch(isUserSet(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetIsUserSet = () => (dispatch) => {
    dispatch(isUserSet(false));
}

export const deleteUserById = (authUserId, status) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .deleteUserById(authUserId, status)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                // dispatch(setAuthUser({}));
                // dispatch(setAuthUser(data.response));
                // dispatch(isUserSet(true));
                dispatch(setIsUserDelete(true));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetIsUserDelete = () => (dispatch) => {
    dispatch(setIsUserDelete(false));
}


export const changeTerminationStatus = (authUserId, terminationStatus) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .changeTerminationStatus(authUserId, terminationStatus)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setIsUserDelete(true));
                // dispatch(setAuthUser({}));
                // dispatch(setAuthUser(data.response));
                // dispatch(isUserSet(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const changeLockStatus = (authUserId, lockStatus) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .changeLockStatus(authUserId, lockStatus)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setIsUserDelete(true));
                // dispatch(setAuthUser({}));
                // dispatch(setAuthUser(data.response));
                // dispatch(isUserSet(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const changePassword = (authUserId, password) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .changePassword(authUserId, password)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                dispatch(setVerifyOtpData(undefined));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const GetMyAccessReport = (d, callBack) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getMyAccessReport(d)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setMyReports(data?.reportDetails));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const SaveReportAccess = (d, callBack) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .SaveReportAccess(d)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(getReportDetailsByCompany(d?.selectedCompany));
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);

                callBack && callBack();
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getReports = (companyId, moduleId, isLangEng) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getReports(companyId, moduleId, isLangEng)
        .then(({ data }) => {
            dispatch(setLoaderAction(false));
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setReports(data.response))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const getReportModule = (companyId, isLangEng) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getReportModule(companyId, isLangEng)
        .then(({ data }) => {
            dispatch(setLoaderAction(false));
            if (data.isTransactionSucceed) {
                dispatch(setReportModules(data.response))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetAllReport = () => (dispatch) => {
    dispatch(setReports([]));
}


export const getAllCompanyList = () => (dispatch) => {
    // dispatch(setLoaderAction(true));
    return apiServices
        .getAllCompanyList()
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                // dispatch(setLoaderAction(false));
                // dispatch(resetSelectedCompany(null));
                dispatch(setCompanyList([]));
                dispatch(setCompanyList(data.response));
                dispatch(setTotalRecordOfUserList(0));

            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getDepartmentByCompanyId = (companyId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getDepartmentByCompanyId(companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setDepartmentList([]));
                dispatch(setDepartmentList(data.companyDepartmentList));
                // dispatch(setTotalRecordOfUserList(0));

            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getDepartmentByRegionId = (regionId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getDepartmentByRegionId(regionId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setDepartmentList([]));
                dispatch(setDepartmentList(data.companyDepartmentList));
                // dispatch(setTotalRecordOfUserList(0));

            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getRegionByCompanyId = (companyId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getRegionByCompanyId(companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setRegionList([]));
                dispatch(setRegionList(data.companyRegionList));
                // dispatch(setTotalRecordOfUserList(0));

            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetTotalRecordOfUserList = (totalRecord) => (dispatch) => {
    setTotalRecordOfUserList(totalRecord);
}

export const getAllDomainList = (selectedCompany) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getAllDomainList(selectedCompany)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setDomainList([]));
                dispatch(setDomainList(data.lstDomains));
                dispatch(setDomainFlag(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const onDomainDelete = (selectedDomain) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getSelectedDomainUsers(selectedDomain)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                // dispatch(setSelectedDomainValues([]));
                if (data.response.length > 0)
                    dispatch(setSelectedDomainValues(data.response));
                else
                    dispatch(resetSelectedDomainValues(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetDomainValues = (confirmationValue, isSelectedUserLoaded) => (dispatch) => {
    dispatch(resetSelectedDomainValues(confirmationValue, isSelectedUserLoaded));
}

export const getBackupUsers = (departmentId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getBackupUsers(departmentId)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setBackupUserList([]));
                dispatch(setBackupUserList(data.response));
                dispatch(setBackupUserFlag(true));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetDomainList = (domainList) => (dispatch) => {
    dispatch(setDomainList(domainList));
    if (!domainList)
        dispatch(setDomainFlag(false));
}

export const saveDomains = (payload) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .saveDomains(payload)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setDomainList([]));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const saveBackupUser = (payload) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .saveBackupUser(payload)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                // dispatch(setDomainList([]));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const deleteBackupUser = (payload) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .deleteBackupUser(payload)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                // dispatch(setDomainList([]));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};



export const getCompanyServiceSettings = (selectedCompany) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getCompanyServiceSettings(selectedCompany)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setCompanyServices(undefined));
                dispatch(setCompanyServices(data.response));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const saveCompanyServiceSetting = (payload, selectedCompany) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .saveCompanyServiceSetting(payload)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(getAuthUserRoles(selectedCompany));
                dispatch(getCompanyServiceSettings(selectedCompany));
                dispatch(setLoaderAction(false));
                dispatch(setCompanyServices(undefined));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
                dispatch(closeRemoveModal());
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const resetSelectedCompany = (companyInfo) => (dispatch) => {
    dispatch(setSelectedCompany(companyInfo));
    dispatch(setAllAuthUsers([]));
    dispatch(setDepartmentList([]));
    if (!companyInfo)
        dispatch(setTotalRecordOfUserList(0));
}

export const resetAuthUser = () => (dispatch) => {
    dispatch(setAuthUser(null));
    dispatch(setBackupUserList([]));
}

export const resetAllAuthUsersAndBackupUser = () => (dispatch) => {
    dispatch(setAllAuthUsers([]));
    dispatch(setBackupUserList([]));
    dispatch(setAuthUser(null));
}

export const resetDomainFlag = (domainFlag) => (dispatch) => {
    dispatch(setDomainFlag(domainFlag));
    // if(!domainFlag)
}

export const resetBackupUserFlag = (BackupUserFlag) => (dispatch) => {
    dispatch(setBackupUserFlag(BackupUserFlag));
    if (!BackupUserFlag)
        dispatch(setBackupUserList([]));
}

export const uploadFileForUserData = (fileData) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .uploadFileForUserData(fileData)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setCompanyServices(undefined));
                dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                setTimeout(() => {
                    dispatch(toastAction.showSuccessMessage(false, ""));
                }, ERROR_TIMEOUT);
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};


export const getUserCompanyServices = () => (dispatch) => {
    return apiServices
        .getUserCompanyServices()
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setUserCompanyServices(data.response));
            } else {
                if (data.errorMessage) {
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                } else {
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                }
            }
        })
        .catch((error) => {
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
        });
};

export const resetIsBackupAssigned = () => (dispatch) => {
    dispatch(setIsBackupAssigned(false));
}

export const resetsuccessMessageForBackupUserAssigned = () => (dispatch) => {
    dispatch(successMessageForBackupUserAssigned(""));
}

export const resetOpenSimpleModalForTermiantion = () => (dispatch) => {
    dispatch(openSimpleModalForTermiantion(false));
}

export const checkIfUserAssignAsBackup = (authUserId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .checkIfUserAssignAsBackup(authUserId)
        .then(({ data }) => {

            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                if (data.isBackupAssigned) {
                    dispatch(setIsBackupAssigned(true));
                    dispatch(successMessageForBackupUserAssigned(data.successMessage));
                }
                else {
                    dispatch(setIsBackupAssigned(false));
                    dispatch(openSimpleModalForTermiantion(true));
                }

                // dispatch(setUserCompanyServices(data.response));
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
        });
};

export const getCompanyAssignedLevel = () => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getCompanyAssignLevels()
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setCompanyAssignedLevels(data.lstData))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const getCompanyLevelItems = (levelNo) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getCompanyLevelsItems(levelNo)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setCompanyLevelItems(data.lstData))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};